// The report param a question's own zoom is stored under (`z`): 'min' (best fit), 'max' (full
// scale) or a dragged [min, max] range. Only a zoom that leaves the report-wide one is kept, so a
// question that follows the report stores nothing.

export const encodeZoomParam = (zoomLevel, globalZoomLevel) =>
  zoomLevel && zoomLevel !== globalZoomLevel ? zoomLevel : null

export const decodeZoomParam = section => section || null

// A pie has no axis to zoom, so a question showing one keeps no zoom of its own.
export const calcZoomSection = (zoomLevel, globalZoomLevel, chartMode) => ({
  z: 'pie' === chartMode ? null : encodeZoomParam(zoomLevel, globalZoomLevel)
})
